import { render } from "./DelivererTab.vue?vue&type=template&id=0e25383c&scoped=true&ts=true"
import script from "./DelivererTab.vue?vue&type=script&lang=ts"
export * from "./DelivererTab.vue?vue&type=script&lang=ts"

import "./DelivererTab.vue?vue&type=style&index=0&id=0e25383c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e25383c"]])

export default __exports__